module.exports = __webpack_public_path__ + "img/logo.1481f242.png";